/* eslint-disable */
export default {
  header: 'Poista virheiden seuranta käytöstä',
  content:
    'Virheidenseurantatilan poistaminen käytöstä poistaa kaikki nykyiset virhelokit. Haluatko jatkaa?',
  confirm: 'Poista käytöstä',
  cancel: 'Peruuta',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
